import "./RegisterPageApp.css";
import Header from "./Navbar";
import Body from "./RegisterPageBody";
import Footer from "./RegisterFooter";

function RegisterPageApp() {
  return (
    <div className="registerpageApp">
      <Header />
      <Body />
      <Footer />
    </div>
  );
}

export default RegisterPageApp;
